import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
	selector: 'case-lookup',
	templateUrl: './app.component.html'
})

export class AppComponent   {
    constructor(private location: Location, private route: ActivatedRoute, private router: Router) { }

    backBtnHidden: boolean = false;
    back() {
        this.location.back();
    }

    ngOnInit() {
        this.router.events.subscribe(data => {
            if (data instanceof NavigationEnd) {
                if (this.route.children[0].firstChild.data['value']) {
                    var routeData = this.route.children[0].firstChild.data['value'];
                    this.backBtnHidden = routeData['hideBackButton'];                  
                }
                window.scrollTo(0, 0);
            }
        })

        this.route.data.subscribe(data => {
            // console.log(data, 'route data in parent component');
        })
    }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/app.component.ts